import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=05c59dd0&scoped=true&"
import script from "./PasswordResetView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PasswordResetView.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=05c59dd0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c59dd0",
  null
  
)

export default component.exports